import React from 'react';

export const Stars: React.FC = () => {
  return <div className="text-lg text-amber-400">{'★ '.repeat(5)}</div>;
};
